import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty } from 'src/app/shared/utilities/obj-utilities';

@Pipe({
    name: 'replace',
    standalone: true
})
export class ReplacePipe implements PipeTransform {
    transform(input: any, pattern: any, replacement: any): any {
        if (this.isNullOrUndefined(input) || this.isNullOrUndefined(pattern) || this.isNullOrUndefined(replacement)) {
            return input ?? '';
        }

        //check if the pattern is a matching Regex exp
        if (input.match(pattern)) {
            return input.replace(pattern, replacement);
        }

        const isInputNull = isEmpty(input);
        const isPatternNull = isEmpty(pattern);
        const isReplacementNull = isEmpty(replacement);

        if (isInputNull || isPatternNull || isReplacementNull) {
            return input;
        }
        return input.replace(pattern, replacement);
    }

    private isNullOrUndefined(value: any) {
        return value === null || value === undefined;
    }
}
